import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';
import { PaginatedResults } from '@trukt/types/PaginatedResults';
import { AxiosInstance } from 'axios';

export interface InvoicePaymentSearchRequest extends PaginatedQueryParams {
  company?: string; // Company's guid
}

export type InvoicePaymentSearchItem = {
  id: string;
  fee: string | null;
  label: string;
  paymentTermsId: string;
  paymentMethodId: string;
  isDeprecated: boolean;
  isDefault: boolean;
};

export type InvoicePaymentSearchResponse = PaginatedResults<InvoicePaymentSearchItem>;

export class InvoicePaymentService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: InvoicePaymentSearchRequest) {
    if (!request.company) delete request.company;

    return this.instance.get<InvoicePaymentSearchResponse>('/invoices/payments', {
      params: request,
    });
  }
}
